import { useContext, useEffect, useState } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import restService from "../../../restService";
import Switch from "./switch";

const BarChart = ({ Highcharts, HighchartsReact, state }) => {
  const charts = ["Bar", "Line"];
  const [currentChart, setCurrentChart] = useState("Bar");
  const [activeTab, setActiveTab] = useState("All");
  const [campaign] = useContext(CampaignContext);
  const [data, setData] = useState({
    totalEntries: [],
    totalWins: [],
    totalValidEntries: [],
    totalInvalidEntries: [],
  });

  // const [state, setState] = useState([
  //   {
  //     startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
  //     endDate: new Date().setHours(23, 59, 59, 0),
  //     key: "selection",
  //   },
  // ]);

  const [date, setDate] = useState([]);

  useEffect(() => {
    getDailyEntries();
  }, [state]);

  const getDailyEntries = async () => {
    try {
      const {
        data: { data },
      } = await restService.Reports.DailyEntries(
        campaign.id,
        new Date(state[0].startDate).toISOString().slice(0, -5),
        new Date(state[0].endDate).toISOString().slice(0, -5)
      );

      const tempDate = [];
      let total = [];
      let wins = [];
      let valid = [];
      let invalid = [];

      for (let i = 0; i < data.length; i++) {
        tempDate.push(data[i]?._id.split("-").reverse().join("-"));
        total.push([
          data[i]?._id.split("-").reverse().join("-"),
          data[i]?.total,
        ]);
        wins.push([data[i]?._id.split("-").reverse().join("-"), data[i]?.wins]);
        valid.push([
          data[i]?._id.split("-").reverse().join("-"),
          data[i]?.valid,
        ]);
        invalid.push([
          data[i]?._id.split("-").reverse().join("-"),
          data[i]?.invalid,
        ]);
      }
      // console.log(new Date(tempDate[0].toDateString()));
      // console.log(new Date(tempDate[0]), "--00");

      const sortTotal = total.sort((a, b) => {
        return new Date(a[0]) - new Date(b[0]);
      });

      const sortWins = wins.sort((a, b) => {
        return new Date(a[0]) - new Date(b[0]);
      });

      const sortValid = valid.sort((a, b) => {
        return new Date(a[0]) - new Date(b[0]);
      });

      const sortInvalid = invalid.sort((a, b) => {
        return new Date(a[0]) - new Date(b[0]);
      });

      setData({
        ...data,
        totalEntries: sortTotal,
        totalWins: sortWins,
        totalValidEntries: sortValid,
        totalInvalidEntries: sortInvalid,
      });

      let dateString = [];

      for (let i = 0; i < tempDate.length; i++) {
        dateString.push(new Date(tempDate[i]).toISOString());
      }

      const sortedDate = dateString.sort((a, b) => {
        return new Date(a).getTime() - new Date(b).getTime();
      });

      setDate(sortedDate.map((d) => new Date(d).toString().substring(0, 15)));
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const options = {
    colors: ["#262C6E", "#72ADFF", "#00C74C", "#FF6A3A"],
    chart: {
      type: currentChart === "Bar" ? "column" : "spline",
    },
    title: {
      text: "",
    },
    legend: {
      // align: "top",
      // layout: "vertical",
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true, // enable exporting module
      csv: {
        dateFormat: "%Y-%m-%d %H:%M:%S",
        columnHeaderFormatter: function (item, key) {
          if (key === "name") {
            return "Date";
          } else {
            return item.name;
          }
        },
      },
      accessibility: {
        enabled: true, // enable accessibility module
      },
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            // "printChart",
            "separator",
            "downloadPNG",
            "downloadJPEG",
            "downloadPDF",
            "downloadSVG",
            "separator",
            "downloadCSV",
          ],
        },
      },
    },

    xAxis: {
      categories: date,
      crosshair: true,
      type: "datetime",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      // pointFormat:
      // '<tr><td style="color:{series.color};padding:0">{series.name}: </td>',
      // '<td style="padding:0"><b>{point.y}</b></td></tr> <br /> <tr><td style="color:{series.color};padding:0">Percentage: </td> { + } <td style="padding:0"><b>{point.percentage:.0f}%</b></td></tr> ',
      // footerFormat: "</table>",
      // shared: true,
      // useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          inside: true,
          style: {
            fontWeight: "bold",
          },
          formatter: function () {
            if (this.y !== 0) {
              return this.y;
            } else {
              return null;
            }
          },
        },
      },
    },
    series: [
      {
        name: "Total Entries",
        data: data.totalEntries,
      },
      {
        name: "Total Valid Entries",
        data: data.totalValidEntries,
      },
      {
        name: "Total Wins",
        data: data.totalWins,
      },
      {
        name: "Total Invalid Entries",
        data: data.totalInvalidEntries,
      },
    ],
  };

  const tab = [
    "All",
    "Valid Entries",
    "Invalid Entries",
    "Wins",
    "Ignored Entries",
  ];

  return (
    <div className="shadow mb-8 bg-white py-6 px-6 w-full">
      <div className="flex mb-6 flex-col md:gap-0 gap-5 md:flex-row md:items-center md:justify-between">
        <p className="text-[#181818] text-base">Daily Entries Breakdown</p>

        {/* <div className="border rounded">
          <DatePicker state={state} setState={setState} />
        </div> */}
      </div>
      <div>
        <Switch
          tabs={charts}
          currentTab={currentChart}
          setCurrentTab={setCurrentChart}
        />
      </div>

      {/* bar chart */}
      <div className="mt-1">
        <HighchartsReact
          // containerProps={{ style: { height: "100%" } }}
          highcharts={Highcharts}
          // options={formatChartData(chartData.total, "Total")}
          options={options}
          // constructorType={"stockChart"}
          updateArgs={[true, true, true]}
        />
      </div>
    </div>
  );
};

export default BarChart;
